module.exports = __webpack_public_path__ + "img/btn-invite.95761a4d.png";